module.exports = __webpack_public_path__ + "img/logo.f2f01f34.png";